export const UPDATE_DURATION_TYPE = {
  extend: 'extend',
  reduce: 'reduce',
};
